export default __webpack_public_path__ + "d4f6c6a2ce1dd79174e618527f28cd08.svg";